import React from "react"
import UserContext from "./UserContext"

const withUser = Component => props => (
  <UserContext.Consumer>
    {userContextProps => <Component {...props} {...userContextProps} />}
  </UserContext.Consumer>
)

export default withUser
